import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { Observable } from 'rxjs';
import {
  MasterAdapterSettingsInterface,
  PartnerAdapterSettingsInterface,
} from '../types/adapter-settings';
import {
  UpsertMasterAdapterSettingsInterface,
  UpsertPartnerAdapterSettingsAddInterface,
  UpsertPartnerAdapterSettingsUpdateInterface,
} from '../types/upsert-adapter-settings';

@Injectable({
  providedIn: 'root',
})
export class AdapterSettingsService {
  constructor(private httpClient: HttpClientService) {}

  // Master Adapter Setting (global catalog of adapter definitions)
  listMasterAdapterSettings(): Observable<
    ResponseIdentity<MasterAdapterSettingsInterface[]>
  > {
    return this.httpClient.post(
      API_URL_CONSTANT.masterAdapterSettings.listAdapters
    );
  }

  addMasterAdapterSetting(
    payload: UpsertMasterAdapterSettingsInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterAdapterSettings.addAdapter,
      payload
    );
  }

  updateMasterAdapterSetting(
    payload: UpsertMasterAdapterSettingsInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterAdapterSettings.updateAdapter,
      payload
    );
  }

  deleteMasterAdapterSetting(code: number): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterAdapterSettings.deleteAdapter,
      { code }
    );
  }

  // Partner Adapter Setting (platform-admin managed; partner_id sent in the body)
  listPartnerAdapterSettings(payload: {
    partner_id: number;
  }): Observable<ResponseIdentity<PartnerAdapterSettingsInterface[]>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterPartnerAdapterSettings.listAdapters,
      payload
    );
  }

  // Same endpoint as listPartnerAdapterSettings: adding `id` narrows the backend
  // response from the partner's array of rows down to that single row, so it is
  // typed separately rather than as a union on the list method.
  getPartnerAdapterSetting(payload: {
    partner_id: number;
    id: number;
  }): Observable<ResponseIdentity<PartnerAdapterSettingsInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterPartnerAdapterSettings.listAdapters,
      payload
    );
  }

  addPartnerAdapterSetting(
    payload: UpsertPartnerAdapterSettingsAddInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterPartnerAdapterSettings.addAdapter,
      payload
    );
  }

  updatePartnerAdapterSetting(
    payload: UpsertPartnerAdapterSettingsUpdateInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterPartnerAdapterSettings.updateAdapter,
      payload
    );
  }

  deletePartnerAdapterSetting(payload: {
    partner_id: number;
    id: number;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.masterPartnerAdapterSettings.deleteAdapter,
      payload
    );
  }
}
